'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Sequence = exports.FitFragment = exports.PlainFragment = exports.FragmentRoot = exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require('react-motion');

var _fragment = require('./fragment');

var _fragment2 = _interopRequireDefault(_fragment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * Class for fragment.
 * @public
 *
 * @class Fragment
 * @param {Object} props
 *   The properties
 * @param {(ReactElement|ReactElement[])} props.children
 * @param {number} props.order
 * @param {?Boolean} props.root
 * @param {Object} context
 *   The context
 */
var Fragment = function (_Component) {
  _inherits(Fragment, _Component);

  _createClass(Fragment, null, [{
    key: 'propTypes',

    /**
     * @private
     */
    get: function get() {
      return {
        children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]).isRequired,
        mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        animation: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string]),
        onRest: _propTypes2.default.func,
        root: _propTypes2.default.bool,
        plain: _propTypes2.default.bool,
        fit: _propTypes2.default.bool,
        order: _propTypes2.default.number.isRequired,
        displayAs: _propTypes2.default.string,
        springSettings: _propTypes2.default.shape({
          stiffness: _propTypes2.default.number,
          damping: _propTypes2.default.number,
          precision: _propTypes2.default.number
        })
      };
    }

    /**
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        animation: undefined,
        mixin: undefined,
        onRest: function onRest() {},

        displayAs: undefined,
        fit: false,
        root: false,
        plain: false,
        springSettings: undefined
      };
    }

    /**
     * Get contextTypes
     * @private
     *
     * @return {{store: store, fragmentHost: number, hostedFragmentOrder: number}}
     */

  }, {
    key: 'contextTypes',
    get: function get() {
      return {
        store: _propTypes2.default.object.isRequired,
        isPreview: _propTypes2.default.bool,
        fragmentOrder: _propTypes2.default.number,
        fragmentHost: _propTypes2.default.number,
        hostedFragmentOrder: _propTypes2.default.number
      };
    }

    /**
     * Sends context to decendants. Includes the app store to allow all deck
     * components to access the store without having to include its own logic.
     * @private
     *
     * @return {{hostedFragmentOrder: number}}
     */

  }, {
    key: 'childContextTypes',
    get: function get() {
      return {
        hostedFragmentOrder: _propTypes2.default.number
      };
    }

    /**
     * @private
     */

  }]);

  function Fragment(props, context) {
    _classCallCheck(this, Fragment);

    var _this = _possibleConstructorReturn(this, (Fragment.__proto__ || Object.getPrototypeOf(Fragment)).call(this, props, context));

    _this.renderChildren = _this.renderChildren.bind(_this);
    return _this;
  }

  /**
   * Gets the child context.
   * @private
   * @return {{hostedFragmentOrder: number}}
   *   The child context.
   */


  _createClass(Fragment, [{
    key: 'getChildContext',
    value: function getChildContext() {
      var _context$hostedFragme = this.context.hostedFragmentOrder,
          hostedFragmentOrder = _context$hostedFragme === undefined ? 0 : _context$hostedFragme;

      return {
        hostedFragmentOrder: this.props.root ? this.props.order + hostedFragmentOrder : hostedFragmentOrder
      };
    }

    /**
     * Before the fragments are mounted we need to tell the application about
     * their existance and behaviour.
     * @private
     */

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      var order = this.props.order;
      var _context = this.context,
          fragmentHost = _context.fragmentHost,
          _context$hostedFragme2 = _context.hostedFragmentOrder,
          hostedFragmentOrder = _context$hostedFragme2 === undefined ? 0 : _context$hostedFragme2;
      // Get the current host to allow extending it.

      var host = this.context.store.fragmentHosts.length - 1 >= fragmentHost ? this.context.store.fragmentHosts[fragmentHost] : [];

      // Handle root components. the root index is added to nested fragments
      // to allow them to be rendered before or after their parent fragment
      var fragmentOrder = order + hostedFragmentOrder;

      // Only add new indexes to the queue.
      // Duplicate indexes will appear at the same time.
      // Root components are respected by definition.
      if (host.indexOf(fragmentOrder) < 0) {
        host.push(fragmentOrder);
      }

      // If no fragment has been defined with `0` we need to add a position to
      // our host
      if (host.length > 0 && host.indexOf(0) < 0) {
        host.push(0);
      }
      // Sort the fragment indexes and update the store
      this.context.store.fragmentHosts[fragmentHost] = host.sort(function (a, b) {
        return a - b;
      });
    }

    /**
     * @private
     * @return {number}
     *   The number of fragment indexes (steps to next slide)
     */

  }, {
    key: 'renderChildren',


    /**
     * @private
     */
    value: function renderChildren(time, isActive) {
      if (typeof this.props.children === 'function') {
        return this.props.children(time, isActive);
      }
      return this.props.children;
    }

    /**
     * @private
     * @return {StyledFragment}
     *   The fragment including the entire logic
     */

  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _context2 = this.context,
          store = _context2.store,
          fragmentHost = _context2.fragmentHost,
          fragmentOrder = _context2.fragmentOrder,
          isPreview = _context2.isPreview,
          _context2$hostedFragm = _context2.hostedFragmentOrder,
          hostedFragmentOrder = _context2$hostedFragm === undefined ? 0 : _context2$hostedFragm;
      // To ensure the correct loading we need to manually attempt to
      // find the correct order. This only happens on slides that have not
      // initially been loaded.

      var _store$fragmentHosts$ = store.fragmentHosts[fragmentHost].length,
          fragmentHostCount = _store$fragmentHosts$ === undefined ? 0 : _store$fragmentHosts$;

      var lastFragment = Math.max(0, fragmentHostCount - 1);
      var _store$fragmentOrder = store.fragmentOrder,
          storedFragmentOrder = _store$fragmentOrder === undefined ? store.fragmentHosts[fragmentHost].length === 0 ? 0 : store.fragmentHosts[fragmentHost][Math.min(store.fragmentIndex, lastFragment)] : _store$fragmentOrder;

      // Define several flags to determine the acitve state
      // of the fragment.

      var isPrev = fragmentHost < store.slideIndex;
      var isCurrent = fragmentHost === store.slideIndex;
      var isNext = fragmentHost > store.slideIndex;
      var totalFragmentOrder = this.props.order + hostedFragmentOrder;
      var isZero = totalFragmentOrder === 0;
      var isActivated = (fragmentOrder || storedFragmentOrder) >= totalFragmentOrder;
      var isActive = isPreview || isPrev || (isNext ? isZero : isActivated);
      var springStyle = {
        t: (0, _reactMotion.spring)(isActive ? 0 : 1, _extends({}, this.props.springSettings))
      };
      var handleRest = function handleRest() {
        return isActive ? _this2.props.onRest(store.fragmentIndex, store.fragmentOrder) : null;
      };
      return _react2.default.createElement(
        _reactMotion.Motion,
        { style: springStyle, onRest: handleRest },
        function (_ref) {
          var t = _ref.t;

          var time = isActive ? t : 1;
          var style = {
            '--time': time
          };
          return _this2.props.plain ? _this2.renderChildren(time, isActive && isCurrent) : _react2.default.createElement(
            _fragment2.default,
            {
              style: style,
              isActive: isActive,
              isFit: _this2.props.fit,
              displayAs: _this2.props.displayAs,
              mixin: _this2.props.mixin,
              animation: _this2.props.animation },
            _this2.renderChildren(time, isActive)
          );
        }
      );
    }
  }, {
    key: 'length',
    get: function get() {
      return this.context.store.fragmentHosts[this.context.fragmentHost].length;
    }
  }]);

  return Fragment;
}(_react.Component);

/**
 * Fragment root component. When using the fragmentRoot, nested Fragments start
 * after the parent. This is a curry version of Fragment.
 * @public
 * @param {Object} props
 * @return {Fragment}
 *   A Fragment component as root
 */


exports.default = Fragment;
var FragmentRoot = exports.FragmentRoot = function FragmentRoot(props) {
  return _react2.default.createElement(Fragment, _extends({}, props, { root: true }));
};

/**
 * Fragment plain component. When using the PlainFragment, no wrapping span is used.
 * This is a curry version of Fragment.
 * @public
 * @param {Object} props
 * @return {Fragment}
 *   A Fragment component as plain
 */
var PlainFragment = exports.PlainFragment = function PlainFragment(props) {
  return _react2.default.createElement(Fragment, _extends({}, props, { plain: true }));
};

/**
 * Fragment fit component. When using the FitFragment, nested elements
 * can use percentage or flex based dimensions.
 * This is a curry version of Fragment.
 * @public
 * @param {Object} props
 * @return {Fragment}
 *   A Fragment component as fit fragment
 */
var FitFragment = exports.FitFragment = function FitFragment(props) {
  return _react2.default.createElement(Fragment, _extends({}, props, { fit: true }));
};

/**
 * Fragment sequence component. When using the Sequence, an array of
 * timelines is returned.
 * @public
 * @param {Object} props
 *   The properties
 * @param {number} props.steps number uf steps
 * @param {number} props.order
 *   The starting order
 * @param {number} props.nextOrder
 *   (protected)
 * @return {Fragment}
 *   A Fragment component as sequence
 */
var Sequence = exports.Sequence = function Sequence(props) {
  var nextOrder = props.nextOrder < props.order ? props.order : props.nextOrder;
  var index = nextOrder - props.order + 1;
  return _react2.default.createElement(
    Fragment,
    _extends({}, props, { order: nextOrder, plain: true }),
    function (fragmentTime, isActive) {
      var _last = nextOrder >= props.order + props.steps - 1;
      var _props$time = props.time,
          time = _props$time === undefined ? fragmentTime : _props$time;

      var timeline = Math.max(0, index - 1 - time) + (_last ? 1 - fragmentTime : 0);
      return isActive && !_last ? _react2.default.createElement(Sequence, _extends({}, props, {
        nextOrder: nextOrder + 1,
        time: fragmentTime,
        root: false
      })) : props.children(Math.ceil(timeline - 1), time + (Math.ceil(timeline) === props.steps ? fragmentTime : 0), timeline);
    }
  );
};

/**
 * @private
 */
Sequence.defaultProps = {
  children: function children() {},
  onRest: function onRest() {},

  time: 1,
  nextOrder: 0,
  order: 0,
  steps: 2

  /**
   * @private
   */
};Sequence.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.func]),
  onRest: _propTypes2.default.func,
  nextOrder: _propTypes2.default.number,
  time: _propTypes2.default.number,
  order: _propTypes2.default.number,
  steps: _propTypes2.default.number
};
//# sourceMappingURL=index.js.map